import { getIntl } from '@umijs/max';
import type { ClassValue } from 'clsx';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

// 枚举

import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { toJsonData } from '@/utils/socket';
import RenderUtil from '@/utils/RenderUtil';
import xlsx from 'json-as-xlsx';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}


export const isLink = (text: string) => {
  const regex = /(https?:\/\/[^\s]+)/g;
  const matches = text?.match?.(regex);
  return matches && matches.length > 0;
};
export const exportExcel = (data: any, fileName?: string) => {
  const settings = {
    fileName: fileName ?? 'export',
    extraLength: 3,
    writeMode: 'writeFile',
    writeOptions: {},
    RTL: true,
  };
  xlsx(data, settings);
};
// 解析 后端的 bankCard 字段
export   const findJsonValue = (field: string,state:any) => {
  return state?.bankCard
    ? toJsonData(state.bankCard)?.find?.((it: any) => it.field === field)?.value
    : '';
};
export function i18n(k: any) {
  return getIntl().formatMessage({ id: k }) ?? k;
}

// 获取到唯一设备码
export async function getFingerprint(): Promise<string> {
  // 初始化 FingerprintJS
  const fp = await FingerprintJS.load();
  // 获取浏览器指纹
  const result = await fp.get();
  // 返回唯一标识符
  return result.visitorId;
}


export function truncateNumber(
  num: number | any,
  decimalPlaces: number,
): string | undefined {
  if (num === undefined) return;
  const strNum = num?.toString?.();
  const [integerPart, decimalPart] = strNum?.split?.('.') ?? [];

  if (decimalPlaces === 0)
    return integerPart;

  if (!decimalPart || decimalPart.length <= decimalPlaces) {
    return strNum;
  }

  return `${integerPart}.${decimalPart.slice(0, decimalPlaces)}`;
}


//解析 后端的字符
export function decodeHTMLEntitiesOptimized(input: any) {
  if (input === undefined || input === null) return '';
  if (!decodeHTMLEntitiesOptimized.textArea) {
    decodeHTMLEntitiesOptimized.textArea = document.createElement('textarea');
  }
  const textArea: any = decodeHTMLEntitiesOptimized.textArea;
  textArea.innerHTML = input;
  return textArea.value;
}

export const clearStorageExcept = (keysToKeep: string[]) => {
  // 保留localStorage中的指定键值
  const localStorageValues: Record<string, string | null> = {};
  keysToKeep.forEach((key) => {
    localStorageValues[key] = localStorage.getItem(key);
  });

  // 清理localStorage
  localStorage.clear();

  // 重新设置指定键值
  Object.keys(localStorageValues).forEach((key) => {
    if (localStorageValues && localStorageValues[key] !== null) {
      localStorage.setItem(key, localStorageValues[key] as string);
    }
  });
};

/**
 * @description 生成一个指定长度的随机字符串，由数字和小写字母组成。
 * @param length 生成的随机字符串的长度。
 * @returns 生成的随机字符串。
 */
export function generateRandomString(length: number) {
  const characters = '0123456789abcdefghijklmnopqrstuvwxyz';
  const timestamp = new Date().getTime().toString();
  const charactersLength = characters.length;
  const timestampLength = timestamp.length;
  const randomValues = new Uint32Array(length);
  const randomBytes = crypto.getRandomValues(randomValues);
  let result = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = randomBytes[i] % charactersLength;
    result += characters.charAt(randomIndex);

    // 在随机位置插入时间戳的字符
    if (i === Math.floor(length / 2)) {
      for (let j = 0; j < timestampLength; j++) {
        const timestampIndex = randomBytes[i + j] % charactersLength;
        result += timestamp.charAt(timestampIndex);
      }
    }
  }

  return result;
}

/**
 * 手动解析url 参数
 * 下面 为 使用demo
 const urlState = useMemo(() => {
 return parseQueryString(window.location.search);
 }, [window.location.search]);
 */

export function parseQueryString(queryString: string) {
  const params = new URLSearchParams(queryString);
  const result: any = {};

  for (const [key, value] of params.entries()) {
    result[key] = value;
  }

  return result;
}

// 增加千分位
export const formatter = (_value: string) => {
  if (!_value) return _value;
  let value = _value?.replace(/\./g, ',');
  //只保留一个小数点
  let dotCount = (value.match(/,/g) || []).length;
  if (dotCount > 1) {
    // 去除最后一个小数点
    const lastDotIndex = value.lastIndexOf(',');
    value = value.slice(0, lastDotIndex) + value.slice(lastDotIndex + 1);
  }
  // 取出整数部分/小数部分
  let [integerPart, decimalPart] = value.split(',');
  // 正则替换
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  if (value?.includes(',')) {
    return integerPart + ',' + (decimalPart ?? '');
  } else {
    return integerPart;
  }
};
//去掉千分位
export const parser = (_value: string) => {
  if (!_value) return _value;
  let value = _value?.toString?.();
  // 取出整数部分
  let integerPart = value.split('.')[0];
  // 取出小数部分
  let decimalPart = value.split('.')[1];
  integerPart = integerPart?.replace(/\$\s?|(,*)/g, '');
  if (value?.includes('.')) {
    return integerPart + '.' + decimalPart;
  } else {
    return integerPart;
  }
};

/**
 * @description 列表数据排序
 */
export const filterListData = (
  value: any,
  list: any,
  options: any,
  setOptions: any,
  params: any,
  setParams: any,
  isStock: boolean = false,
  isBulk?: boolean,
) => {
  // 点击触发排序
  if (value.type === 'click') {
    const paramsToUpdate = isStock
      ? { ...params }
      : { ...params, upDownRangSort: 0 };

    const findIndex = options.findIndex(
      (item: any) => item.id === value.data.id,
    );
    if (findIndex !== -1) {
      options[findIndex].sort =
        options[findIndex].sort === ''
          ? 'asc'
          : options[findIndex].sort === 'asc'
            ? 'desc'
            : '';

      setOptions(
        options?.map((item: any, index: number) => {
          if (index === findIndex) {
            return item;
          }
          return {
            ...item,
            sort: '',
          };
        }),
      );
    }
    const listIndex = list?.findIndex(
      (item: any) => item?.id === value?.data?.id,
    );
    const paramsNumberSort =
      listIndex !== -1
        ? list[listIndex].sort === 'desc'
          ? -1
          : list[listIndex].sort === 'asc'
            ? 1
            : 0
        : 0;

    switch (value.data.type) {
      case 1:
        paramsToUpdate['priceSort'] = paramsNumberSort;
        delete paramsToUpdate.upDownRangSort;
        break;
      case 2:
        paramsToUpdate['upDownRangSort'] = paramsNumberSort;
        delete paramsToUpdate.priceSort;
        break;
      case 3:
        break;
    }
    console.log(paramsToUpdate);
    setParams(paramsToUpdate);
  }

  // 弹窗 【原IPO，IEO,DISTRIBUTION】
  if (value?.type === 'modal') {
    let updatedParams: any = {};
    // 赋值
    updatedParams = { ...params, partition: value.data.value as any };
    setParams(updatedParams);
  }
};

/**
 * 将 JPY 转换为 USD
 * @param {number} jpy - 日元金额
 * @param {number} [exchangeRate=155] - 汇率（可选，默认值为 155）
 * @returns {number} 转换后的美元金额，保留两位小数
 */
export function jpyToUsd(jpy = 0, exchangeRate = 155) {

  // 转换汇率计算
  const usd = jpy / exchangeRate;

  // 返回保留两位小数的金额
  return RenderUtil.formatNum(usd);
}


export const formatCountdown = (ms: number): string => {
  const hours = String(Math.floor(ms / (1000 * 60 * 60))).padStart(2, '0'); // 小时
  const minutes = String(
    Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60)),
  ).padStart(2, '0'); // 分钟
  const seconds = String(Math.floor((ms % (1000 * 60)) / 1000)).padStart(
    2,
    '0',
  ); // 秒
  return `${hours}:${minutes}:${seconds}`;
};
